function showPassword(el) {
    el.addEventListener('click', (e) => {
        el.parentElement.classList.toggle('show');
        el.previousElementSibling.type === 'password' ? el.previousElementSibling.type = 'text' : el.previousElementSibling.type = 'password';
    });
}

window.addEventListener("load", (e) => {
  let fileEl = document.getElementById("jsFile"),
    fileTargetEl = document.getElementById("jsFileTarget");
  if (fileEl && fileTargetEl) {
    fileEl.addEventListener("change", (e) => {
      if (fileEl.files && fileEl.files[0]) {
        fileTargetEl.src = URL.createObjectURL(e.target.files[0]);
      }
    });
  }

  let showPasswordEls = document.querySelectorAll('.jsShowPassword');
  if(showPasswordEls) {
    showPasswordEls.forEach(showPasswordEl => {
        showPassword(showPasswordEl);
    });
  }
});
